import { nodeEq } from './utils';

export default function shouldShowMenu({triggerItem,thisNodeInfo}){
  let thisNodeIsTrigger = nodeEq(triggerItem,thisNodeInfo);
  let childAtnIsTrigger = thisIsTriggerAtnParent(triggerItem,thisNodeInfo.node);

  return thisNodeIsTrigger || childAtnIsTrigger;

}

function thisIsTriggerAtnParent(triggerItem,thisNode){

  let { c } = thisNode;
  if( !c ){
    return false;
  }

  let triggerId = triggerItem.nodeId;
  let isVirtualNode = triggerId.includes("v_")

  let verdict = isVirtualNode && c.includes(triggerId);

  return verdict;
  

}
